import CloseIcon from '@mui/icons-material/Close';
import { Modal, ModalProps } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { IBulletinMessage } from '../../routes/welcome/WelcomeData';
import { AutomatedBulletinMessageComp } from '../AutomatedBulletinMessageComp';
import { BulletinMessageComp } from '../BulletinMessageComp';
import { CloseIconStyle, CloseIconWrapperStyle, GridContainerStyle, ModalBackdropStyle, ModalStyle } from './styled';

export interface IBulletinMessageModalCompProps {
  bulletins: IBulletinMessage[];
  automatedBulletins: IBulletinMessage[];
}

export const BulletinMessageModalComp = ({
  bulletins,
  automatedBulletins
}: IBulletinMessageModalCompProps) => {
  const [openAutomatedMsgs, setOpenAutomatedMsgs] = useState(true);
  const [openMsgs, setOpenMsgs] = useState(true);
  const [dismissedAutomatedArr, setDismissedAutomatedArr] = useState<number[]>([]);
  const [dismissedBulletinsArr, setDismissedBulletinsArr] = useState<number[]>([]);

  useEffect(() => {
    if (dismissedAutomatedArr.length === automatedBulletins.length) {
      setOpenAutomatedMsgs(false);
    }
  }, [dismissedAutomatedArr.length, automatedBulletins.length]);

  useEffect(() => {
    if (dismissedBulletinsArr.length === bulletins.length) {
      setOpenMsgs(false);
    }
  }, [dismissedBulletinsArr.length, bulletins.length]);

  const handleDismissAutomated = (index: number) => {
    setDismissedAutomatedArr(prev => [...prev, index]);
  };

  const handleDismissBulletin = (index: number) => {
    setDismissedBulletinsArr(prev => [...prev, index]);
  };

  const isModalOpen = openAutomatedMsgs || openMsgs;
  return (
    <Modal
      sx={ModalStyle}
      open={isModalOpen}
      slotProps={{
        backdrop: {
          style: ModalBackdropStyle,
        }
      } as ModalProps['slotProps']}
    >
      <>
        {/* Automated Bulletins Section */}
        {openAutomatedMsgs && (
          <Grid sx={{ ...GridContainerStyle, mb: 1 }} container>
            <Grid sx={CloseIconWrapperStyle} className={`${automatedBulletins[0]?.priority}`} item xs={10} sm={6} md={3} xl={2}>
              <CloseIcon
                sx={CloseIconStyle}
                onClick={() => setOpenAutomatedMsgs(false)}
              />
              {automatedBulletins.map((msg, i) => (
                dismissedAutomatedArr.indexOf(i) === -1 && (
                  <AutomatedBulletinMessageComp
                    closeHandler={() => handleDismissAutomated(i)}
                    key={`automated-${i}`}
                    {...msg}
                  />
                )
              ))}
            </Grid>
          </Grid>
        )}

        {/* Regular Bulletins Section */}
        {openMsgs && (
          <Grid sx={GridContainerStyle} container>
            <Grid sx={CloseIconWrapperStyle} item xs={10} sm={6} md={3} xl={2}>
              <CloseIcon
                sx={CloseIconStyle}
                onClick={() => setOpenMsgs(false)}
              />
              {bulletins.map((msg, i) => (
                dismissedBulletinsArr.indexOf(i) === -1 && (
                  <BulletinMessageComp
                    closeHandler={() => handleDismissBulletin(i)}
                    key={`bulletin-${i}`}
                    {...msg}
                  />
                )
              ))}
            </Grid>
          </Grid>
        )}
      </>
    </Modal>
  );
};
